
export default [
    {
        path: '/relatorios', component: () => import('@/components/relatorios/layout/Layout'), name: 'relatorios.page', children: [
            {path: '', component: () => import('./components/Index'), name: 'relatorios.main'},
            {path: 'leiloes/visualizacao', component: () => import('./apps/leiloes/Visualizacao'), name: 'relatorio.leiloes-visualizacoes'},
            {path: 'produtividade', component: () => import('./apps/produtividade/ProdutividadePeriodo'), name: 'relatorio.produtividade.periodo'}
        ]
    }
]
